module.exports = __webpack_public_path__ + "static/img/4.6bff6d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/4.png
// module id = 2TkI
// module chunks = 0